// extracted by mini-css-extract-plugin
module.exports = {"container":"IconTitleCmp_container__1mpBB","title":"IconTitleCmp_title__F9Y_v"};